module.exports = __webpack_public_path__ + "static/img/tututu@2x.612ab26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tututu@2x.png
// module id = tpSj
// module chunks = 18